import { ApiGetServerUserResponse } from 'src/api'
import { Applications } from 'src/applications'

const HOOMVIP_APP_ID = '139383EA23244E0DB7F976B2C101FBDB'

const APPS_TO_FILTER = [HOOMVIP_APP_ID]

const iconDataMap: { [key: string]: string } = {
  '8E7E8A8F3311436AA0819F29AE3C02C1': '/assets/app_icons/actividades.svg',
  '4FF5305EB58047709B1332E60832A99F': '/assets/app_icons/administracion.svg',
  '6BC39B80DE99479C8B6F9023723E05EF': '/assets/app_icons/alertas.svg',
  AD1D8662E2A44212BD3199C2B3EF92E4: '/assets/app_icons/bloqueos.svg',
  '9542887F67E64F499DD9B4D91BC0ED97': '/assets/app_icons/channel_manager.svg',
  '37D5BB4138F54A5C8E8EF00BE8D2D02D': '/assets/app_icons/clientes.svg',
  '8E8E3DD8C82B478FB6FA7D4842642180': '/assets/app_icons/comunicaciones.svg',
  '010E771C35144352AC6509AF0D5B518E': '/assets/app_icons/conceptos.svg',
  '430D531D46C24A5C86B304E9AE29CF7F': '/assets/app_icons/configuracion.svg',
  '59B6C7CD8B3F454E880323B6DCC44B9C': '/assets/app_icons/consola.svg',
  BA04BC75CD2D41D09D4959DBD221CD62: '/assets/app_icons/cupones.svg',
  '1003DB18F54B4E229180A026CB97072F': '/assets/app_icons/facturas.svg',
  '92C7962122EE4B8B9EBD686AB4F79BC7': '/assets/app_icons/gastos.svg',
  '148B479D81424BC398826AAAB0C0EC0C': '/assets/app_icons/gestion_ingresos.svg',
  '283497FA042E45289C0BBA57D6CC0630': '/assets/app_icons/informes.svg',
  E800B5FC23CB46DF9CA25DC9C9AF8FBF: '/assets/app_icons/integraciones.svg',
  F690BC5A11BA4283B5596DA1C4D67492: '/assets/app_icons/limpieza.svg',
  '45AB739C84074B329BAF8D811D63DB7D': '/assets/app_icons/mensajes.svg',
  AD2CDDFFCD144CE79EF23344D212522E: '/assets/app_icons/planning.svg',
  FA7173B34F87435281984AF871B1EE8D: '/assets/app_icons/presupuestos.svg',
  '92CB03FEC8834CE89A29B6F1C6EDACE0': '/assets/app_icons/propietarios.svg',
  CE40DFE29EE7498EAF7AB9C4ADCF2D9B: '/assets/app_icons/reservas.svg',
  C1CFB67F4BDF4B5A980A2AB5E8FAFC85: '/assets/app_icons/roles.svg',
  domoticWindowId: '/assets/app_icons/domotica.svg',
  '9B0D0AE015E1415B9B8F8BA98D4EFBDC':
    '/assets/app_icons/sincronizar_canales.svg',
  planningSquareWindowId: '/assets/app_icons/estado.svg'
}

const newApps = Object.values(Applications)

export const adaptApiGetServerUserResponse = (
  response: ApiGetServerUserResponse
): ApiGetServerUserResponse => {
  return {
    ...response,
    iconDataList: response.iconDataList
      .filter(({ id }) => !APPS_TO_FILTER.includes(id))
      .map((serverApp) => {
        const newApp = newApps.find(({ id }) => id === serverApp.id)
        const newIcon: string | undefined =
          iconDataMap[serverApp.id] ?? serverApp.icon
        if (!newApp) return { ...serverApp, icon: newIcon }
        return {
          ...serverApp,
          iFrame: undefined,
          id: newApp.id,
          icon: newApp.icon,
          isNew: newApp.isNew,
          app: newApp.app
        }
      })
  }
}
